module.exports = __webpack_public_path__ + "static/media/colourful_kits.fe277b47.jpg";